import toDisplayName from "./toDisplayName.js";

export default (orderNo, businessCode, realm) => {
  const name = toDisplayName(businessCode, realm);

  return `#${orderNo}${name ? `(${name})` : ""}`;
};
